export default (context => ({
  colour: {
    successLight: context.colour.allhomesAqua100,
    successDark: context.colour.allhomesAqua400,
    infoLight: context.colour.allhomesCeruleanblue100,
    infoDark: context.colour.allhomesCeruleanblue400
  }
}));